import React from 'react';

import styled from 'styled-components';
import LogoCsCat from './../../img/Logos Consorci-SEPE.jpg';

//Condiciones del curso en el formulario principal 
const CondicionesCurso = () => {
    return (
        <>
            <Contenedor>
                <Img src={LogoCsCat} width={600} />
                <p>La superación del curso supone la obtención de un diploma acreditativo que 
                   incluye el logotipo del Ministerio de Trabajo y Economía Social del Gobierno de España
                    y el del Consorcio de formación de Cataluña.</p>
             
                <p>“Estas acciones formativas están dentro del marco de la resolución de 10 de junio de 2025, 
                    por la que se abre la convocatoria de 2025 de los programas de formación profesional para el empleo, 
                    de especialidades de la oferta de formación no formal, para personas trabajadoras ocupadas, 
                    que promueve el Consorcio para la Formación Continua de Cataluña (ref. BDNS 839118)” </p>
            </Contenedor>

        </>
    );
}

const Contenedor = styled.div`
    text-align: center;
    padding-left: 25%;
    padding-right: 25%;
    margin-top: 2%;
    padding-bottom: 7%;
    p{
        color: #7A7A7A;
        font-family: 'Roboto';
    }

    @media screen and (max-width: 768px) {
        padding-left: 10%;
        padding-right: 10%;
    }

`;

const Img = styled.img`
    margin-top: 5%;
    margin-bottom: 5%;
    width: 600px;

    @media screen and (max-width: 768px) {
        width:315px;
        
    }

`;



export default CondicionesCurso;